import { render, staticRenderFns } from "./MyYoutubePlayer.vue?vue&type=template&id=63c9aeb6&"
import script from "./MyYoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./MyYoutubePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports